<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item>
              {{ displayText("data_chart.title", "報表中心") }}
            </b-breadcrumb-item>

            <b-breadcrumb-item active>LINE 推播紀錄</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <div
        class="
          d-flex
          flex-column flex-xl-row
          align-items-start align-items-xl-center
          justify-content-between
          mb-4 mb-xl-2
        "
      >
        <h4
          class="col-12 col-xl-2 mb-2 mb-xl-0 font-weight-bold"
        >
          LINE 推播紀錄
        </h4>
        <div class="row-searchbar col-xl-10 mb-10 d-flex justify-content-end mb-2 mb-md-0 mr-md-2">
            <h6 class="my-auto">
                搜尋時間
            </h6>
            <DateSearchPicker
                class="mr-md-1 mr-0 col-5"
                v-model="query"
                :disabledEndAtDates.sync="disabledEndAtDates"
                :startedPlaceholder="displayText('data_chart.partner_worker_chart_search_start_date', 'Start Date')"
                :endedPlaceholder="displayText('data_chart.partner_worker_chart_search_end_date', 'End Date')"
            />
            <h6 class="mr-2 my-auto">
              搜尋訊息
            </h6>
            <b-form-input
              class="mr-md-1 mr-0 col-2"
              v-model="query.keyword"
              v-on:keyup.enter="handleSearch"
              placeholder="搜尋訊息"
            ></b-form-input>
            <b-button @click="handleSearch"><i class="fa fa-search"></i></b-button>
        </div>
    </div>

      <b-card-text>
        <div class="row">
          <div class="col-12">
            <b-overlay :show="showLoading" rounded="sm">
              <b-table
                striped
                hover
                responsive
                :items="pushedMessages"
                :fields="fields"
                show-empty
              >
                <template #cell(customer_name)="data">
                  <router-link
                    :to="{ name: 'PushedMessageDetail', params: { pushed_message_id: data.item.id } }"
                    class="text-primary"
                  >
                    {{ data.value || data.item.outer_code }}
                  </router-link>
                </template>
                <template #empty>
                    <div class="text-center text-muted">
                    <p>查無資料</p>
                    </div>
                </template>
              </b-table>
            </b-overlay>
          </div>
        </div>
        <div class="container" style="margin-top: 80px">
          <div class="row justify-content-center align-items-center">
            <div class="col-12 col-md-auto mb-3">
              <span>目前第 {{ currentPage }} 頁 / 總共 {{ Math.ceil(totalRows / query.per_page) }} 頁</span>
            </div>

            <div class="col-12 col-md-auto mb-3">
              <b-pagination
                class="my-auto"
                v-if="totalRows > 0"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="query.per_page"
              ></b-pagination>
            </div>

            <div class="col-12 col-md-auto mb-3">
              <span>每頁顯示數量：</span>
              <b-form-select
                v-model="query.per_page"
                :options="perPageOption"
                class="d-inline-block"
                style="width: auto;"
                @change="getPushedMessages"
              ></b-form-select>
              <span> / 總數量: {{ totalRows }}</span>
            </div>
          </div>
        </div>

      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapState, mapGetters } from "vuex";
import dataChartApi from "@/apis/data-chart";
import { displayText } from "@/utils/dashboardUtils";
import DateSearchPicker from "@/components/Page/Dashboard/DateSearchPicker";

export default {
  components: {
    DateSearchPicker,
  },
  data() {
    return {
      perPageOption: [
        { text: "10", value: 10 },
        { text: "20", value: 20 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
      ],
      currentPage: 1,
      totalRows: 0,
      showLoading: true,
      pushedMessages: [],
      query: {
        start_at: "",
        end_at: "",
        per_page: 10,
        page: 1,
        keyword: "",
      },
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
      dashboardModule: (state) => state.dashboardModule,
    }),
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    disabledEndAtDates() {
      return { to: new Date(this.query.start_at) };
    },
    fields() {
      let fields = [
        {
          key: "type",
          label: "通路",
        },
        {
          key: "sub_type",
          label: "類型",
        },
        {
          key: "customer_name",
          label: "推播對象",
        },
        {
          key: "staff_name",
          label: "員工",
        },
        {
          key: "branch_name",
          label: "分店",
        },
        {
          key: "memo",
          label: "備註",
        },
        {
          key: "status",
          label: "狀態",
          formatter: (value) => {
            if (!value) return '-';
            return value === 'success' ? '成功' : value === 'failed' ? '失敗' : value;
          }
        },
        {
          key: "count",
          label: "數量"
        },
        {
          key: "created_at",
          label: "發送時間",
          formatter: (value) => {
            if (!value) return '-';
            return format(new Date(value), 'yyyy-MM-dd HH:mm:ss');
          }
        }
      ];
      return fields;
    },
  },
  watch: {
    currentPage: function (newPage, oldPage) {
      if (newPage === oldPage) return;
      this.query.page = newPage;
      this.getPushedMessages();
    },
  },
  async created() {
  },
  async mounted() {
    await this.getPushedMessages();
  },
  methods: {
    format,
    displayText,
    handleSearch() {
      this.currentPage = 1;
      this.getPushedMessages();
    },
    async getPushedMessages() {
      this.showLoading = true;
      try {
        const { data } = await dataChartApi.getPushedMessages(
          this.query
        );
        console.log(this.query)
        this.pushedMessages = data.data
        this.totalRows = data.meta.total;
      } catch (error) {
        console.error(error);
        if (error.status !== 401) {
          this.$swal.fire({
            title: "錯誤",
            type: "error",
            text: displayText("partner.api_failed", "讀取資料錯誤"),
          });
        }
      }
      this.showLoading = false;
    },
  },
};
</script>
<style scoped>
.btn + .btn {
  margin-left: 0.5rem;
}
.row-searchbar {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

/* 改善連結的視覺效果 */
.text-primary {
  color: #007bff !important;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.text-primary:hover {
  color: #0056b3 !important;
  text-decoration: underline;
}

.text-primary:visited {
  color: #6610f2 !important;
}

.text-primary:active {
  color: #0056b3 !important;
}
</style>
